var $ = require('jquery');
var _ = require('lodash');

var Voting = function(el) {
    this.$el = $(el);
    this.$form = this.$el.find('.voting-form');
    this.$results = this.$el.find('.voting-results');
    this.$chart = this.$el.find('.results-chart');
    this.$el.find('.vote').on('click', $.proxy(this.vote, this));
    this.$message = this.$el.find('.results-messages');
    this.$spinner = this.$el.find('.spinner');
    this.url = this.$el.data('url');
    $('.show-results').on('click', $.proxy(this.show_results, this));
    this.is_open = !!this.$el.data('open');
    this.can_show_results = !!this.$el.data('show');
    if (this.is_open) {
        this.can_vote();
    }
};

Voting.prototype.render_results = function(data) {
    this.$chart.html(data.html);
};

Voting.prototype.toggle_spinner = function(value) {
    if (value) {
        this.$form.find('.vote button').hide();
    }
    this.$spinner.toggleClass('active', value);
};

Voting.prototype.set_message = function(data, post_success) {
    var msg = '';
    if (!data) {
        data = {};
    }

    if (this.is_open) {
        if (post_success !== undefined) {
            if (post_success === false) {
                msg = '\u00c4\u00e4nest\u00e4minen ep\u00e4onnistui. ';
            } else {
                msg = 'Kiitos \u00e4\u00e4nest\u00e4si. ';
            }
        } else if (data.can_vote === false){
            msg = 'Olet jo \u00e4\u00e4nest\u00e4nyt t\u00e4ss\u00e4 \u00e4\u00e4nestyksess\u00e4. ';
        }
    }
    if (this.can_show_results === false) {
        msg += '\u00c4\u00e4nestyksen tulokset julkaistaan my\u00f6hemmin. ';
    } else if (data.targets && (!data.targets.length || !data.vote_count)) {
        msg += 'Ei viel\u00e4 tarpeeksi \u00e4\u00e4ni\u00e4. ';
    }

    this.$message.html('<div>'+ msg + '</div>');
};

Voting.prototype.can_vote = function() {
    var that = this;
    $.get(this.url+'?can_vote=1')
        .success(function(data) {
            if (data) {
                that.toggle_spinner(false);
                that.render_results(data);
                if (data.can_vote === false) {
                    that.set_message(data);
                    that.show_results();
                }
                else {
                    that.$form.show();
                }
            } else {
                that.$form.show();
            }

        }
    );
};

Voting.prototype.show_results = function() {
    this.$form.hide();
    this.$results.show();
};


Voting.prototype.vote = function(e) {
    var $el = $(e.target);
    var data = {'target': $el.data('id')};
    var that = this;
    this.toggle_spinner(true);
    $.post(this.url, data)
        .fail(function(){
            that.set_message(data, false);
        }).success(function(data){
            that.set_message(data, true);
        }).always(function(data) {
            that.toggle_spinner(false);
            that.render_results(data);
            that.show_results();
        });
};

$(function () {
    $('.voting').each(function(i, el) {
        new Voting(el);
    });
});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/site/js/voting.js
// module id = 15
// module chunks = 0